import type { ReactNode } from "react";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  action?: ReactNode;
}) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        isCenter ? "md:flex-col md:items-center md:text-center" : "md:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : ""}>
        {eyebrow ? (
          <span className="mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-600 uppercase">
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </span>
        ) : null}
        <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}